import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LayoutAdminModule } from '../../layout/admin/layout-admin.module';
import { SharedModule } from '../../shared/shared.module';
import { AdjustmentsAuditComponent } from './adjustments-audit.component';
import { AdjustmentsAuditRoutes } from './adjustments-audit.routes';

@NgModule({
    declarations: [AdjustmentsAuditComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        AdjustmentsAuditRoutes,
        LayoutAdminModule,
        SharedModule
    ]
})
export class AdjustmentsAuditModule {}
